import ROUTES from 'library/constants/routes';
import Input from 'library/components/form/input';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { login } from 'store/users/actions';
import { getUserLoading } from 'store/users/selectors';
import * as yup from 'yup';
import {
  Container,
  ConfirmButton,
  StyledForm,
  StyledLogo,
  TextContainer,
  StyledTitle,
} from './styles';

export const VALIDATION = yup.object().shape({
  email: yup.string()
    .required('Email is required'),
  password: yup.string()
    .required('Password is required'),
});

// temporary component for auth purposes
const SignIn = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(getUserLoading);
  const methods = useForm({
    resolver: yupResolver(VALIDATION),
    mode: 'onChange',
    defaultValues: {
      email: '',
      password: '',
    },
  });
  const { isDirty, isValid } = methods.formState;

  const onSuccess = () => {
    props.history.push(ROUTES.DASHBOARD);
  };
  // eslint-disable-next-line no-unused-vars
  const handleSubmit = (data) => {
    dispatch(login({ data, onSuccess }));
  };

  return (
    <Container>
      <FormProvider {...methods}>
        <StyledForm onSubmit={methods.handleSubmit(handleSubmit)}>
          <Input
            placeholder="Email"
            iconClassName="icon-pencil"
            name="email"
            required
          />
          <Input
            placeholder="Password"
            iconClassName="icon-pencil"
            name="password"
            type="password"
          />
          <ConfirmButton
            type="submit"
            disabled={isDirty && !(isValid || isLoading)}
            aria-label="Login"
          >
            Login
          </ConfirmButton>
        </StyledForm>
      </FormProvider>
    </Container>

  );
};

export default SignIn;
